<template>
  <div id="App">
      <div class="head">
        <!-- 第一层 -->
          <div class="head-top">
            <div id="w-center" class="hede-top-won">
              <span>欢迎访问山西医疗信息化交流服务平台——一站式医疗信息化服务平台</span>
              <span>
                  <el-link :underline="false" @click="logout"  v-if="userid>0">退出登录</el-link>
                  |
                 <!-- <router-link :to="`/`">
                      <el-link :underline="false">返回主页</el-link>
                  </router-link>
                  | -->
                  <router-link :to="`/Member`">
                      <el-link :underline="false">会员中心</el-link>
                  </router-link>
              </span>
            </div>
          </div>
      </div>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        info:[],
        keyword:'',
        pieces:[],
        select:'1',
        userid:0,
      }
    },
    components: {
    },
    mounted () {
      this.recordapi();
    },
    methods:{

      logout(){
        console.log(1);
          this.$confirm('确定要退出登录吗?', '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
            }).then(() => {
              this.$message({
                 type: 'success',
                 message: '退出成功!'
               });
               //确认退出，清除token
              this.$cookieStore.delCookie('userid');
              // localStorage.removeItem('token')
               //跳转登录页面(编程式导航)
               this.$router.push('/login')

          }).catch(() => {
          this.$message({
          type: 'info',
          message: '已取消退出'
          });
        });
      },


      recordapi(){
          var that = this;
          var userid = that.$cookieStore.getCookie('userid');
          var userid = that.$cookieStore.getCookie('userid');
          if(userid){
            this.userid = userid;
          }
          that.$api.post("/Login/Loginshow",{'userid':userid}).then(res => {
            console.log(res);
            that.info= res;
            that.pieces= res.pieces;
          });
      },

      sousuo(){
        // if(this.keyword==''){
        //   this.$message.error('请输入您要搜索的产品');
        //   return
        // }

        if(this.select == 1){
           this.$router.push('/Products?index=2&keyword='+this.keyword);
           this.$emit('sou');
        }else if(this.select == 2){
          this.$router.push('/News?index=4&keyword='+this.keyword)
          this.$emit('sou');
        }else if(this.select == 3){
          this.$router.push('/Qiyelist?index=8&keyword='+this.keyword)
          this.$emit('sou');
        }

        // this.$router.push('/Products?index=2&keyword='+this.keyword)
        this.$emit('sou');
      },


    }

   }
</script>



// WEBPACK FOOTER //
// src/components/public/head.vue